import React, {ReactElement, useEffect} from "react";
import {UiSegementedButtonType} from "./UiSegementedButton";


type SegementedButtonsType = {
    className?: string;
    onChange: (key: string | number) => void;
    children: ReactElement<UiSegementedButtonType>[]
}

export const UiSegementedButtons: React.FC<SegementedButtonsType> = (props) => {

    const [selected, setSelected] = React.useState<number>(0);

    useEffect(() => {
        if (props.children.length === 0) return;

        let index = selected;
        if (props.children.length <= selected) {
            setSelected(0);
            index = 0;
        }

        props.onChange(props.children[index].key!);
    }, [props.children]);
    
    return (
        <div className={(props.className ? `${props.className} `: "") + "flex items-center rounded-2xl " +
            "bg-deep-blue gap-2 p-1.5"}>
            
            {props.children.map((value, index) => (
                React.cloneElement(value, {
                    _onClick: () => {
                        if (index === selected) return;
                        
                        setSelected(index);
                        props.onChange(value.key!);
                    },
                    className: (index === selected ? "bg-purple-blue " : "")
                })
            ))}
        </div>
    )
}
